import React from 'react'
import { Button, Stack, Typography } from '@mui/material'
import * as S from './styles'
import { Container, PasswordInputField } from 'src/ui'
import { Formik, Form } from 'formik'
import useSignup, { initialValues, validate } from './ResetPassword.State'
import SetupMfa from '../Mfa/SetupMfa'
import { Box } from '@mui/system'
import { Navigate, useSearchParams } from 'react-router-dom'

const ResetPassword: React.FC = () => {
  const { state, setState, onSubmit, invalidURL } = useSignup()
  const [searchParams] = useSearchParams()
  const isNewPasswordRequired = searchParams.get('newPasswordRequired') === 'true'

  if (invalidURL) {
    return <Navigate to="/login" replace />
  }

  return !state.success ? (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const { errors, bar } = validate(values)
        setState({ ...state, bar })
        return errors
      }}
      onSubmit={onSubmit}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Container
            title={isNewPasswordRequired ? 'Set your new password' : 'Reset your password'}
            error={state.error}
          >
            <Stack spacing={3}>
              <Typography variant="body2">Please enter your new password down below.</Typography>
              <Box>
                <PasswordInputField state={{ strengthColor: state.bar.strengthColor, value: state.bar.value }} />
                <S.PasswordHelper variant="subtitle2">
                  Your password should have at least 8 characters, one uppercase, one lowercase, one number and one
                  special character
                </S.PasswordHelper>
              </Box>
              <Button
                variant="contained"
                size="large"
                // disabled={!(dirty && isValid)}
                loading={isSubmitting}
                onClick={submitForm}
                fullWidth
              >
                Reset password
              </Button>
            </Stack>
          </Container>
        </Form>
      )}
    </Formik>
  ) : (
    <>{state.setupMfa && <SetupMfa open enforced setupMfaParams={state.setupMfaParams} />}</>
  )
}

export default ResetPassword
